import { apiRoutesConstants } from '@plugin/Common/constants/cross-sell/api-routes.constants'
import { CrossSellServiceInterface } from '@plugin/Common/interfaces/cross-sell/api/cross-sell-service.interface'
import { CrossSellProductInterface } from '@plugin/Common/interfaces/cross-sell/entities/cross-sell-product.interface'
import { GetProductRecordsResponseInterface } from '@plugin/Common/interfaces/cross-sell/get-product-records-response.interface'
import { HttpClientService } from '@plugin/Common/services/cross-sell/api/http-client.service'

class CrossSellService extends HttpClientService implements CrossSellServiceInterface {
  async getRecordsForCart(): Promise<CrossSellProductInterface[]> {
    try {
      const response = await this.get<any>(apiRoutesConstants.getForCart)
      return response.Records.map(this.convertApiProduct)
    } catch (err) {
      // TODO: Address this tech debt by adding proper type checking
      // @ts-expect-error Untyped error handling
      return HttpClientService.handleError(err)
    }
  }

  async getRecordsForProduct(productId: number): Promise<GetProductRecordsResponseInterface> {
    try {
      const response = await this.get<any>(apiRoutesConstants.getForProduct(productId))
      const output: GetProductRecordsResponseInterface = {
        product: this.convertApiProduct(response.Product),
        records: response.Records.map(this.convertApiProduct),
      }
      return output
    } catch (err) {
      // TODO: Address this tech debt by adding proper type checking
      // @ts-expect-error Untyped error handling
      return HttpClientService.handleError(err)
    }
  }

  async getSettingsForProduct(productId) {
    return await this.get(apiRoutesConstants.getSettingsForProduct(productId))
  }

  protected convertApiProduct(apiProduct): CrossSellProductInterface {
    return {
      description: apiProduct.Description,
      id: apiProduct.Id,
      imageUrl: apiProduct.ImageUrl,
      name: apiProduct.Name,
      price: apiProduct.Price,
      priceLabel: apiProduct.PriceLabel,
      url: apiProduct.Url,
    }
  }
}

const crossSellService = new CrossSellService(apiRoutesConstants.basePath)
export { crossSellService, CrossSellService }
